import { render, staticRenderFns } from "./item_count.vue?vue&type=template&id=246d44ef&"
import script from "./item_count.vue?vue&type=script&lang=js&"
export * from "./item_count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports